import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginUser, logoutUser } from "../modules/actions";
import Login from "./View";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      loginUser,
      logoutUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
